import React from 'react';
import { io } from 'socket.io-client';

const URL = 'https://socket.salescaptain.com';

export const socket = io(URL, {
  transports: ['websocket'],
  autoConnect: false,
});

// Basic lifecycle logging for visibility
socket.on('connect', () => {
  // eslint-disable-next-line no-console
  console.log('Socket connected:', socket.id);
});

socket.on('disconnect', (reason) => {
  // eslint-disable-next-line no-console
  console.log('Socket disconnected:', reason);
});
export function connectSocketFromLocalStorage(companyId) {
  try {
    const compId = companyId ?? localStorage.getItem('compid');
    if (!compId) {
      if (socket.connected) {
        socket.disconnect();
      }
      return;
    }
    if (socket.connected) {
      socket.disconnect();
    }
    socket.io.opts.query = { compId: companyId };
    socket.io.opts.forceNew = true; 
    socket.connect();
  } catch (err) {
    console.error('Error connecting socket:', err);
  }
}

export function disconnectSocket() {
  try {
    if (socket.connected) {
      socket.disconnect();
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Error disconnecting socket:', err);
  }
}

export const SocketContext = React.createContext();
